module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lnPuo"))).then(() => parcelRequire('f4eak'));